var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0676 13.9473C31.5209 13.4006 30.5742 13.774 30.5742 14.534V19.1873C30.5742 21.134 32.2276 22.7473 34.2409 22.7473C35.5076 22.7606 37.2676 22.7606 38.7742 22.7606C39.5342 22.7606 39.9342 21.8673 39.4009 21.334C37.4809 19.4006 34.0409 15.9206 32.0676 13.9473Z",
    fill: "url(#paint0_linear_19039_71465)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 24.588H34.4787C31.3187 24.588 28.7454 22.0146 28.7454 18.8546V15.0013C28.7454 14.268 28.1454 13.668 27.412 13.668H21.7587C17.652 13.668 14.332 16.3346 14.332 21.0946V32.908C14.332 37.668 17.652 40.3346 21.7587 40.3346H32.2387C36.3454 40.3346 39.6654 37.668 39.6654 32.908V25.9213C39.6654 25.188 39.0654 24.588 38.332 24.588ZM26.332 34.668H20.9987C20.452 34.668 19.9987 34.2146 19.9987 33.668C19.9987 33.1213 20.452 32.668 20.9987 32.668H26.332C26.8787 32.668 27.332 33.1213 27.332 33.668C27.332 34.2146 26.8787 34.668 26.332 34.668ZM28.9987 29.3346H20.9987C20.452 29.3346 19.9987 28.8813 19.9987 28.3346C19.9987 27.788 20.452 27.3346 20.9987 27.3346H28.9987C29.5454 27.3346 29.9987 27.788 29.9987 28.3346C29.9987 28.8813 29.5454 29.3346 28.9987 29.3346Z",
    fill: "url(#paint1_linear_19039_71465)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19039_71465",
    x1: 30.5742,
    y1: 13.6875,
    x2: 40.7591,
    y2: 15.1824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19039_71465",
    x1: 14.332,
    y1: 13.668,
    x2: 42.8353,
    y2: 17.6434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#795EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CC5DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.e642cd590b9e195f3a57084cd27cd339.svg";
export { ForwardRef as ReactComponent };